import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
    en: {
        translation: {
            // Common
            'welcome': 'Welcome to Phú Quốc Rental',
            'loading': 'Loading...',
            'error': 'An error occurred',
            'save': 'Save',
            'cancel': 'Cancel',
            'delete': 'Delete',
            'edit': 'Edit',
            'view': 'View',
            'search': 'Search',
            'filter': 'Filter',
            'sort': 'Sort',
            'next': 'Next',
            'previous': 'Previous',
            'submit': 'Submit',

            // Navigation
            'home': 'Home',
            'vehicles': 'Vehicles',
            'tours': 'Tours',
            'news': 'News',
            'shorts': 'Shorts',
            'login': 'Login',
            'register': 'Register',
            'logout': 'Logout',
            'dashboard': 'Dashboard',
            'profile': 'Profile',
            'settings': 'Settings',

            // Vehicles
            'motorcycles': 'Motorcycles',
            'cars': 'Cars',
            'taxis': 'Taxis',
            'daily_rate': 'Daily Rate',
            'hourly_rate': 'Hourly Rate',
            'book_now': 'Book Now',
            'add_to_cart': 'Add to Cart',
            'availability': 'Availability',
            'features': 'Features',
            'reviews': 'Reviews',

            // Booking
            'start_date': 'Start Date',
            'end_date': 'End Date',
            'pickup_location': 'Pickup Location',
            'dropoff_location': 'Dropoff Location',
            'total_amount': 'Total Amount',
            'book_vehicle': 'Book Vehicle',

            // Wallet
            'wallet': 'Wallet',
            'balance': 'Balance',
            'deposit': 'Deposit',
            'withdraw': 'Withdraw',
            'transactions': 'Transactions',
            'transaction_history': 'Transaction History',

            // Auth
            'email': 'Email',
            'password': 'Password',
            'full_name': 'Full Name',
            'phone': 'Phone',
            'sign_in': 'Sign In',
            'sign_up': 'Sign Up',
            'sign_in_with_google': 'Sign in with Google',
            'forgot_password': 'Forgot Password?',
            'already_have_account': 'Already have an account?',
            'dont_have_account': "Don't have an account?",

            // Cart
            'cart': 'Cart',
            'cart_empty': 'Your cart is empty',
            'checkout': 'Checkout',
            'remove_from_cart': 'Remove from cart',

            // Admin
            'admin_panel': 'Admin Panel',
            'manage_vehicles': 'Manage Vehicles',
            'manage_bookings': 'Manage Bookings',
            'manage_users': 'Manage Users',
            'manage_withdrawals': 'Manage Withdrawals',
            'approve': 'Approve',
            'reject': 'Reject',
            'pending': 'Pending',
            'approved': 'Approved',
            'rejected': 'Rejected',
            'completed': 'Completed',
        }
    },
    vi: {
        translation: {
            // Common
            'welcome': 'Chào mừng đến Thuê Xe Phú Quốc',
            'loading': 'Đang tải...',
            'error': 'Đã xảy ra lỗi',
            'save': 'Lưu',
            'cancel': 'Hủy',
            'delete': 'Xóa',
            'edit': 'Sửa',
            'view': 'Xem',
            'search': 'Tìm kiếm',
            'filter': 'Lọc',
            'sort': 'Sắp xếp',
            'next': 'Tiếp',
            'previous': 'Trước',
            'submit': 'Gửi',

            // Navigation
            'home': 'Trang chủ',
            'vehicles': 'Xe',
            'tours': 'Tour',
            'news': 'Tin tức',
            'shorts': 'Video ngắn',
            'login': 'Đăng nhập',
            'register': 'Đăng ký',
            'logout': 'Đăng xuất',
            'dashboard': 'Bảng điều khiển',
            'profile': 'Hồ sơ',
            'settings': 'Cài đặt',

            // Vehicles
            'motorcycles': 'Xe máy',
            'cars': 'Ô tô',
            'taxis': 'Taxi',
            'daily_rate': 'Giá theo ngày',
            'hourly_rate': 'Giá theo giờ',
            'book_now': 'Đặt ngay',
            'add_to_cart': 'Thêm vào giỏ',
            'availability': 'Tình trạng',
            'features': 'Tính năng',
            'reviews': 'Đánh giá',

            // Booking
            'start_date': 'Ngày bắt đầu',
            'end_date': 'Ngày kết thúc',
            'pickup_location': 'Địa điểm nhận xe',
            'dropoff_location': 'Địa điểm trả xe',
            'total_amount': 'Tổng tiền',
            'book_vehicle': 'Đặt xe',

            // Wallet
            'wallet': 'Ví',
            'balance': 'Số dư',
            'deposit': 'Nạp tiền',
            'withdraw': 'Rút tiền',
            'transactions': 'Giao dịch',
            'transaction_history': 'Lịch sử giao dịch',

            // Auth
            'email': 'Email',
            'password': 'Mật khẩu',
            'full_name': 'Họ và tên',
            'phone': 'Số điện thoại',
            'sign_in': 'Đăng nhập',
            'sign_up': 'Đăng ký',
            'sign_in_with_google': 'Đăng nhập với Google',
            'forgot_password': 'Quên mật khẩu?',
            'already_have_account': 'Đã có tài khoản?',
            'dont_have_account': 'Chưa có tài khoản?',

            // Cart
            'cart': 'Giỏ hàng',
            'cart_empty': 'Giỏ hàng trống',
            'checkout': 'Thanh toán',
            'remove_from_cart': 'Xóa khỏi giỏ',

            // Admin
            'admin_panel': 'Quản trị',
            'manage_vehicles': 'Quản lý xe',
            'manage_bookings': 'Quản lý đặt xe',
            'manage_users': 'Quản lý người dùng',
            'manage_withdrawals': 'Quản lý rút tiền',
            'approve': 'Phê duyệt',
            'reject': 'Từ chối',
            'pending': 'Chờ xử lý',
            'approved': 'Đã duyệt',
            'rejected': 'Đã từ chối',
            'completed': 'Hoàn thành',
        }
    }
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        }
    })

export default i18n
